import { Platform, StyleSheet, ViewStyle } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { HEADER_HEIGHT } from "../header/Header.style";

const MAIN_CONTAINER_WIDTH = 2560;

const RADIUS = 64;

const style = () => {
  const {
    borderRadiusFull,
    borderWidth2,
    colorBgPrimaryLight,
    colorBgRose,
    colorBorderInput,
    colorText,
    colorTextError,
    colorTextMedium,
    space05,
    space1,
    space10,
    space12,
    space16,
    space2,
    space4,
    space5,
    space6,
    space8,
  } = theme();

  const styleSheet = StyleSheet.create({
    actionButtonLarge: {
      flex: 1,
    },
    actionButtonsWrapper: {
      flexDirection: "row",
      marginBottom: space5,
    },
    addToWishlistButton: {
      alignItems: "center",
      borderColor: colorBorderInput,
      borderRadius: borderRadiusFull,
      borderWidth: borderWidth2,
      height: RADIUS,
      justifyContent: "center",
      marginLeft: space2,
      padding: space2,
      width: RADIUS,
    },
    benefitsBannerLarge: {
      padding: 0,
    },
    benefitsContainerLarge: {
      alignItems: "flex-start",
      display: "flex",
      marginBottom: space5,
      overflow: "hidden",
      width: "100%",
    },
    benefitsContainerSmall: {
      borderBottomColor: colorBgPrimaryLight,
      borderBottomWidth: space1,
      display: "flex",
      marginBottom: space5,
      width: "100%",
    },
    benefitsTitleLarge: {
      marginBottom: 0,
    },
    brand: {
      color: colorTextMedium,
      marginRight: space05,
    },
    brandWrapper: {
      flexDirection: "row",
      flexFlow: "wrap",
      marginBottom: space2,
    } as ViewStyle,
    deliveryInfo: {
      paddingBottom: space12,
    },
    discount: {
      color: colorTextError,
      textAlign: "right",
    },
    distributionGap: {
      marginRight: space6,
    },
    distributionLarge: {
      flexShrink: 1,
      zIndex: 3,
    },
    distributionSmall: {
      marginBottom: space6,
      zIndex: 3,
    },
    distributionsWrapperLarge: {
      flexDirection: "row",
      marginBottom: space16,
      paddingHorizontal: space10,
      paddingTop: space6,
    },
    fashionModelContainer: {
      marginBottom: space1,
    },
    fashionModelLabel: {
      color: colorText,
    },
    fashionModelValue: {
      color: colorTextMedium,
    },
    footer: {
      left: 0,
      right: 0,
    },
    header: {
      height: HEADER_HEIGHT,
    },
    labelWrapper: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-start",
    },
    labelsContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      width: "100%",
    },
    largeProductImageWrapper: {
      paddingRight: space16,
    },
    largeWrapper: {
      flexDirection: "row",
    },
    modalContent: {
      paddingHorizontal: space6,
    },
    modalTitle: {
      marginBottom: space1,
      width: "100%",
    },
    noStockLabel: {
      marginRight: space2,
      paddingBottom: space1,
    },
    onethird: {
      maxWidth: "33.3333%",
      paddingHorizontal: space12,
      paddingTop: space4,
    },
    priceContent: {
      display: "flex",
      flexDirection: "row",
    },
    productBrandLarge: {
      marginBottom: space2,
    },
    productBrandPricingLarge: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      marginBottom: space5,
    },
    productBrandPricingSmall: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "space-between",
      paddingHorizontal: space6,
      paddingVertical: space4,
    },
    productBrandSmall: {
      marginBottom: space1,
    },
    productImageWrapper: {
      alignItems: "flex-start",
    },
    productInfoWrapperLarge: {
      display: "flex",
      flexDirection: "column",
      ...Platform.select({
        web: {
          top: 48,
          position: "sticky",
        },
      }),
    } as ViewStyle,
    productInfoWrapperSmall: {
      borderBottomColor: colorBgPrimaryLight,
      borderBottomWidth: space1,
      display: "flex",
      flexDirection: "column",
      paddingHorizontal: space6,
      paddingVertical: space8,
    },
    productNameLarge: {
      marginRight: space4,
    },
    productNameWrapperLarge: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginBottom: space4,
    },
    returnInfoTitleLarge: {
      marginBottom: space1,
      padding: 0,
    },
    returnInfoTitleSmall: {
      marginBottom: space2,
      padding: 0,
    },
    salesPricing: {
      color: colorTextMedium,
      marginRight: space2,
      textDecorationLine: "line-through",
    },
    scrollView: {
      flex: 1,
      maxWidth: MAIN_CONTAINER_WIDTH,
    },
    sectionTitleLarge: {
      marginBottom: space1,
    },
    sectionTitleSmall: {
      marginBottom: space2,
    },
    sizeGuideText: {
      color: colorTextMedium,
    },
    sizeSelectorLarge: {
      marginBottom: space5,
    },
    sizeSelectorSmall: {
      marginBottom: space6,
    },
    smallWrapper: {
      paddingLeft: 0,
      paddingRight: 0,
    },
    twothird: {
      maxWidth: "66.6666%",
    },
    watchDistributions: {
      alignItems: "center",
      flexDirection: "row",
      marginBottom: space6,
    },
    watchDistributionsIcon: {
      marginRight: space2,
    },
    watchDistributionsText: {
      textDecorationLine: "underline",
    },
  });

  return {
    ...styleSheet,
    colorText,
    colorBgRose,
    colorTextMedium,
  };
};

export { style };
